// @ts-nocheck
import React, { useEffect } from "react";
import withAdminAuth from "../components/HOC/withAdminAuthPage";
import { useSelector, useDispatch } from "react-redux";
import { AssetBreadCrumb, PageContainer } from "../components/AssetBreadCrumb";
import { fetchAllPublicProfiles } from "../store/publicProfileSlice";
import ProfilePictureRounded from "../components/ProfilePictureRounded";

// Renders one profile card, honoring each show* toggle (hidden values are already null on the record, but we also guard on the toggle so the UI never surfaces an opted-out field).
const ProfileCard = ({ profile, kindLabel }) => (
  <div className="bg-white rounded-lg border border-gray-200 p-4 flex items-center gap-3">
    {profile.showProfilePicture && profile.profilePictureUrl ? (
      <ProfilePictureRounded pictureURL={profile.profilePictureUrl} diameter={40} />
    ) : (
      <div className="w-10 h-10 rounded-full bg-gray-200" />
    )}
    <div className="min-w-0">
      <p className="font-medium text-gray-900 truncate">
        {(profile.showDisplayName && profile.displayName) || "Unnamed"}
      </p>
      <p className="text-xs text-gray-400">{kindLabel}</p>
      {profile.showEmail && profile.email && (
        <p className="text-sm text-gray-500 truncate">{profile.email}</p>
      )}
      {profile.showBio && profile.bio && (
        <p className="text-sm text-gray-500 mt-1 line-clamp-2">{profile.bio}</p>
      )}
    </div>
  </div>
);

const PublicProfilesPage = () => {
  const dispatch = useDispatch();
  const { allProfiles, allOrgProfiles } = useSelector((state) => state.publicProfile);

  useEffect(() => {
    dispatch(fetchAllPublicProfiles());
  }, [dispatch]);

  return (
    <PageContainer fullHeight>
      <AssetBreadCrumb assetGroupName="Public Profiles" />
      <div className="flex-1 min-h-0 overflow-hidden flex flex-col">
        <div className="shrink-0 px-8 py-6">
          <h1 className="text-2xl font-bold text-gray-900">Public Profiles</h1>
          <p className="mt-1 text-sm text-gray-500">
            Every public-facing user and organization profile. Used to verify profiles render
            correctly.
          </p>
        </div>

        <div className="flex-1 min-h-0 p-8 overflow-y-auto">
          <div className="max-w-4xl mx-auto">
            <h3 className="text-lg font-semibold text-gray-800 mb-3">Organizations</h3>
            {allOrgProfiles.length === 0 ? (
              <p className="text-gray-400 mb-6">No public organization profiles yet.</p>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
                {allOrgProfiles.map((p) => (
                  <ProfileCard key={p.id} profile={p} kindLabel="Organization" />
                ))}
              </div>
            )}

            <h3 className="text-lg font-semibold text-gray-800 mb-3">Users</h3>
            {allProfiles.length === 0 ? (
              <p className="text-gray-400">No public user profiles yet.</p>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {allProfiles.map((p) => (
                  <ProfileCard key={p.id} profile={p} kindLabel="User" />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

// Admin-nav page: gate at the component level too, so a direct URL hit by a non-admin redirects instead of rendering (issue #694, finding 4). Server-side @auth on the underlying models remains the real data protection.
export default withAdminAuth(PublicProfilesPage);
